import round from './round';

export default round;
